var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.node.group)?_c('span',[_vm._v(_vm._s(_vm.params.value))]):_c('span',[_vm._v(_vm._s(_vm.mValue))])}
var staticRenderFns = []

export { render, staticRenderFns }